import {
	Box,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	SelectProps,
	Typography,
} from '@mui/material';
import React, { useId } from 'react';
import useErrorScrollContext from '../../../../hooks/useErrorScrollContext';
import styles from './InvoiceEditPaymentScheduleSelect.module.scss';

export type InvoiceEditPaymentScheduleSelectProps = Omit<
SelectProps,
'labelId' | 'label' | 'error'
> & { errorText?: string };

export const InvoiceEditPaymentScheduleSelect: React.FC<
InvoiceEditPaymentScheduleSelectProps
> = ( { value, errorText, ...props } ) => {
	const labelId = useId();
	const label = 'Installments';
	const ref = useErrorScrollContext<HTMLDivElement>( !!errorText );
	return (
		<Box className={ styles.container } ref={ ref }>
			<Typography>Select the number of installments:</Typography>
			<FormControl
				fullWidth
				className={ styles.selectContainer }
				error={ !!errorText }
			>
				<InputLabel id={ labelId }>{ label }</InputLabel>
				<Select
					value={ value || '' }
					{ ...props }
					labelId={ labelId }
					label={ label }
					data-cy='payment-installment-schedule'
				>
					{ [ ...Array( 11 ).keys() ].slice( 1 ).map( ( number ) => (
						<MenuItem key={ `item_${ number }` } value={ number }>
							{ number }
						</MenuItem>
					) ) }
				</Select>
				{ errorText ? <FormHelperText>{ errorText }</FormHelperText> : null }
			</FormControl>
		</Box>
	);
};
